import { Skeleton } from '@reveni-io/reveni-ui'

import { skeletonBlocks, skeletonFields } from './constants'
import * as Styles from './styles'

const WidgetAndPopupTabSkeleton = () => {
  return (
    <Styles.Container data-testid="widgetAndPopupTabSkeleton">
      {skeletonBlocks.map(block => (
        <Styles.Block key={block}>
          <Skeleton variant="text" width={120} height={28} />
          <Skeleton variant="text" width="60%" height={20} />
          <Skeleton variant="rounded" width="100%" height={40} />
          <Styles.Content>
            <Styles.Fields>
              {skeletonFields.map(field => (
                <Skeleton key={field} variant="rounded" width="100%" height={56} />
              ))}
            </Styles.Fields>
            <Skeleton variant="rounded" width="100%" height={160} />
          </Styles.Content>
        </Styles.Block>
      ))}
    </Styles.Container>
  )
}

export default WidgetAndPopupTabSkeleton
